/* eslint-disable */
import { Button, Col, Row, Container, Card, Badge } from "react-bootstrap";
import { useEffect, useState } from "react";
import {
  FaProductHunt,
  FaPencil,
  FaTrash,
  FaEye,
  FaCircleExclamation,
  FaUser,
  FaCalendarDay,
  FaComment,
  FaLock,
} from "react-icons/fa6";
import "./ModernViewer.css";

import dayjs from "dayjs";

const relativeTime = require("dayjs/plugin/relativeTime");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
const advancedFormat = require("dayjs/plugin/advancedFormat");

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);

const dateFormat = "MM/DD/YYYY HH:mm z";
const tz = "America/New_York";

const ModernNotesViewer = (props) => {
  const [controls, setControls] = useState(false);

  useEffect(() => {
    setControls(props.controls);
  }, [props.controls]);

  const notes = props.notes || [];
  const deleteNote = props.deleteNote;
  const refreshNotes = props.refresh;
  const setMessage = props.setMessage;
  const showEyeballs = props.showEyeballs;

  if (!notes || notes.length === 0) {
    return (
      <Container>
        <Row>
          <Col>
            <Card className="text-center">
              <Card.Body>
                <FaComment className="mb-2 text-muted" size={24} />
                <Card.Text className="text-muted">
                  No notes have been added to this timeline.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container>
      <Row>
        <Col>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span className="text-muted">
              {notes.length} note{notes.length !== 1 ? "s" : ""} in timeline
            </span>
          </div>
        </Col>
      </Row>

      {notes.map((note) => {
        const created = dayjs(note.created).tz(tz);
        const multiline = note.message.split(`\n`).map((line, index) => (
          <p key={index} className="mb-1">
            {line}
          </p>
        ));

        return (
          <Row key={note.id} className="mb-3">
            <Col>
              <Card
                data-testid={`note-card-${note.id}`}
                className={`note-card ${note.private ? "private-note" : ""} ${
                  note.important ? "important-note" : ""
                }`}
              >
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="note-info">
                      <div className="note-badges mb-2">
                        {note.private && (
                          <Badge
                            data-testid="note-badge-private"
                            bg="secondary"
                            className="me-1"
                          >
                            <FaLock className="me-1" />
                            Private
                          </Badge>
                        )}
                        {note.important && (
                          <Badge
                            data-testid="note-badge-important"
                            bg="danger"
                            className="me-1"
                          >
                            <FaCircleExclamation className="me-1" />
                            Important
                          </Badge>
                        )}
                        {!note.private && showEyeballs && (
                          <Badge
                            data-testid="note-badge-public"
                            bg="info"
                            className="me-1"
                          >
                            <FaEye className="me-1" />
                            Public
                          </Badge>
                        )}
                        {note.pir && (
                          <Badge
                            data-testid="note-badge-pir"
                            bg="primary"
                            className="me-1"
                          >
                            <FaProductHunt className="me-1" />
                            PIR
                          </Badge>
                        )}
                      </div>

                      <div className="note-details mb-2">
                        <div className="detail-row">
                          <FaCalendarDay className="me-1" />
                          <span className="detail-label">Posted:</span>
                          <span
                            data-testid="note-posted-timestamp"
                            className="detail-value"
                          >
                            {created.format(dateFormat)}
                          </span>
                          <span className="text-muted ms-2">
                            ({created.fromNow()})
                          </span>
                        </div>

                        {controls && note.author && (
                          <div className="detail-row">
                            <FaUser className="me-1" />
                            <span className="detail-label">Author:</span>
                            <span
                              data-testid="note-author-name"
                              className="detail-value"
                            >
                              {note.author.name}
                            </span>
                          </div>
                        )}
                      </div>

                      <div className="note-content">
                        <div
                          className={`note-message ${
                            note.private ? "private-message" : ""
                          }`}
                        >
                          {multiline}
                        </div>
                      </div>
                    </div>

                    {controls && (
                      <div className="note-actions">
                        <Button
                          data-testid={`note-edit-${note.id}`}
                          variant="outline-warning"
                          size="sm"
                          className="me-2"
                          onClick={() => setMessage(note)}
                        >
                          <FaPencil className="me-1" />
                          Edit
                        </Button>
                        <Button
                          data-testid={`note-delete-${note.id}`}
                          variant="outline-danger"
                          size="sm"
                          onClick={() => {
                            deleteNote(note.id).then(() => {
                              refreshNotes();
                            });
                          }}
                        >
                          <FaTrash className="me-1" />
                          Delete
                        </Button>
                      </div>
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        );
      })}
    </Container>
  );
};

export default ModernNotesViewer;
